// extracted by mini-css-extract-plugin
export default {"featureListContainer":"FeatureList_partner_featureListContainer__7+-nt","successIcon":"FeatureList_partner_successIcon__t4YE5"};